import {
  Directive,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Performantes Autoplay: Das Video lädt und spielt erst, wenn es im Viewport
 * sichtbar wird, und pausiert wieder, sobald es den Viewport verlässt.
 *
 * Voraussetzung im Template: `preload="none"` und ein `poster`; das
 * `autoplay`-Attribut entfernen (diese Directive steuert Play/Pause).
 *
 *   <video appAutoplayInView muted loop playsinline preload="none"
 *          poster="…"><source src="…" type="video/mp4"></video>
 */
@Directive({
  selector: 'video[appAutoplayInView]',
  standalone: true,
})
export class AutoplayInViewDirective implements OnInit, OnDestroy {
  private io?: IntersectionObserver;

  constructor(
    private el: ElementRef<HTMLVideoElement>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const video = this.el.nativeElement;
    // Autoplay-Policy: Ton muss aus sein
    video.muted = true;
    (video as any).playsInline = true;

    if (typeof IntersectionObserver === 'undefined') {
      this.safePlay();
      return;
    }

    this.io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.safePlay();
          } else if (!video.paused) {
            video.pause();
          }
        }
      },
      { threshold: 0.2 }
    );
    this.io.observe(video);
  }

  ngOnDestroy(): void {
    this.io?.disconnect();
  }

  private safePlay(): void {
    const p = this.el.nativeElement.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        /* Autoplay ggf. blockiert – Poster bleibt sichtbar */
      });
    }
  }
}
